/* eslint-disable no-undef */
// Host class (Accepts a render module)
import * as THREE from "three";
import { rttUniforms } from "./uniforms";
import { ShaderStore } from "./utils";
let tinycolor = require("tinycolor2");

export class Host {
    constructor(_module) {
        this.innerWidth = 0.0;
        this.outterWidth = 0.0;
        this.gameWidth = globalWidth;
        this.gameHeight = globalHeight;
        this.rttShader = null;
        this.renderer = null;
        this.textureRTT = null;
        this.scene = null;
        this.camera = null;
        this.module = _module;
        this.module.setup(this.gameWidth, this.gameHeight, document.getElementById('scene'));
    }
    onWindowResize() {
        if (this.renderer == null) { return; }
        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();
        rttUniforms.resolution.value.x = this.renderer.domElement.width;
        rttUniforms.resolution.value.y = this.renderer.domElement.height;
        this.renderer.setSize(window.innerWidth, window.innerHeight);
    }
    createRenderTexture() {
        const texture = new THREE.WebGLRenderTarget(this.gameWidth, this.gameHeight, {
            format: THREE.RGBFormat,
            minFilter: THREE.LinearFilter,
            magFilter: THREE.LinearFilter,
        });
        texture.texture.minFilter = THREE.LinearFilter;
        texture.texture.magFilter = THREE.LinearFilter;
        return texture;
    }
    createRenderTarget() {
        this.camera = new THREE.OrthographicCamera(
            window.innerWidth / -2,
            window.innerWidth / 2,
            window.innerHeight / 2,
            window.innerHeight / -2, -10000,
            10000
        );
        this.camera.position.z = -100;
        this.scene = new THREE.Scene();
        const light = new THREE.DirectionalLight(0xffffff);
        light.position.set(0, 0, 0).normalize();
        this.scene.add(light);
        let plane = new THREE.PlaneBufferGeometry(
            window.innerWidth,
            window.innerHeight
        );
        this.textureRTT = this.createRenderTexture();
        this.rttShader = new THREE.ShaderMaterial({
            uniforms: JSON.parse(JSON.stringify(rttUniforms)),
            transparent: true,
            vertexColors: THREE.FaceColors,
            vertexShader: ShaderStore.get("v_basic"),
            fragmentShader: ShaderStore.get("f_basic")
        });
        this.rttShader.uniforms.phase.value = 1;
        this.rttShader.uniforms.t0.value = this.textureRTT.texture;
        let rttQuad = new THREE.Mesh(plane, this.rttShader);
        rttQuad.position.x = 0;
        rttQuad.position.y = 0;
        rttQuad.position.z = 0;
        this.scene.add(rttQuad);
    }
    handleKeyboardEvent(event) {
        event.preventDefault();
    }
    handleMouseEvent(event) {
        event.preventDefault();
        if (this.module.handleMouse != null) {
            this.module.handleMouse(event);
        }
    }
    addEventHandlers() {
        document.addEventListener('keydown', this.handleKeyboardEvent.bind(this), false);
        document.addEventListener('keyup', this.handleKeyboardEvent.bind(this), false);
        document.addEventListener('mousedown', this.handleMouseEvent.bind(this), false);
        document.addEventListener('mouseup', this.handleMouseEvent.bind(this), false);
        document.addEventListener('mousemove', this.handleMouseEvent.bind(this), false);
    }
    setup() {
        let domScene = document.getElementById("scene");
        this.renderer = new THREE.WebGLRenderer();
        this.renderer.sortObjects = false;
        this.renderer.setClearColor(tinycolor("#000000").toHexString());
        this.renderer.setSize(window.innerWidth, window.innerHeight);
        this.renderer.setPixelRatio(window.devicePixelRatio);
        domScene.appendChild(this.renderer.domElement);
        this.createRenderTarget();
        this.onWindowResize();
        window.addEventListener("resize", this.onWindowResize.bind(this), false);
        this.addEventHandlers();
        this.render();
    }
    // TODO - the render loops need to be updated to work with the
    //        latest render target process
    render() {
        const self = this;
        this.rttShader.uniforms.resolution.value.x = this.gameWidth;
        this.rttShader.uniforms.resolution.value.y = this.gameHeight;
        this.renderer.setRenderTarget(this.textureRTT);
        this.module.render(this.renderer);
        this.renderer.setRenderTarget(null);
        this.renderer.render(this.scene, this.camera);
        requestAnimationFrame(function () {
            self.render();
        });
    }
}
